import moment from 'moment';

const timeFormat = 'HH:mm';
const dateFormat = 'YYYY-MM-DD';
const dateTimeFormat = 'YYYY-MM-DD HH:mm';

const generateDatesOfMonth = (_year, _month, startingDayOffset = 0) => {
	// init
	const year = _year === undefined ? moment().year() : _year;
	const month = _month === undefined ? moment().month() : _month;

	// create start blank area
	const firstDateOfMonth = moment(`${year}-01-01`).month(month);
	const firstDayOfMonth = parseInt(firstDateOfMonth.format('d')) - startingDayOffset;
	const startBlanks = Array(firstDayOfMonth < 0 ? 7 + firstDayOfMonth : firstDayOfMonth).fill('');

	// create end blank area
	const endDateOfMonth = moment(firstDateOfMonth).endOf('month');
	const endDayOfMonth = parseInt(endDateOfMonth.format('d')) - startingDayOffset;
	const endBlanks = Array(7 - (endDayOfMonth < 0 ? 7 + endDayOfMonth : endDayOfMonth)).fill('');

	const totalDays = firstDateOfMonth.daysInMonth();
	const dates = Array(totalDays)
		.fill('')
		.map((_, i) => moment(firstDateOfMonth).date(i + 1).format(dateFormat));

	let rows = [], cells = [];
	const totalSlots = [...startBlanks, ...dates, ...endBlanks];
	totalSlots.forEach((row, i) => {
		if(i % 7 !== 0) {
			cells.push(row);
		} else {
			rows.push(cells);
			cells = [row];
		}
	});
	return rows;
}

const generateTimeOptions = (minuteInterval) => {
	const timeFormat = 'HH:mm';

	// invalid valid
	if(60 % minuteInterval) return [];

	const optionLength = 24 * (60 / minuteInterval);
	return Array(optionLength).fill('').map((e, i) => ({
		label: moment().hour(0).minute(0).add(i * minuteInterval, 'minute').format(timeFormat),
		value: moment().hour(0).minute(0).add(i * minuteInterval, 'minute').format(timeFormat),
	}));
};

const getCurrentTimeValue = (timeOptions, currentDateTime, format = dateTimeFormat) => {
	const currentMoment = moment(currentDateTime, dateTimeFormat);
	const currentDate = currentMoment.format(dateFormat);
	const currentTime = currentMoment.format(timeFormat);

	let currentTimeValue = '';
	for(let i = 0; i < timeOptions.length; i++) {
		if(currentTime <= timeOptions[i].value || (i === timeOptions.length - 1)) {
			currentTimeValue = timeOptions[i].value;
			break;
		}
	}
	return `${currentDate} ${currentTimeValue}`;
};

const generateDefaultValue = (rawValue, rawTimeOptions, showTime) => {
	/*
		rawTimeOptions can be array of time options or minuteInterval
	*/
	let value = '';
	if(rawValue) {
		if(showTime) {
			value = rawValue;
		} else {
			const tmp = moment();
			// rawValue is '2020-04-25'
			value = moment(rawValue)
				.hour(tmp.hour())
				.minute(tmp.minute())
				.format(dateTimeFormat);
		}
	} else {
		value = moment().format(dateTimeFormat);
	}

	let timeOptions;
	if(typeof rawTimeOptions === 'number') {
		// generate timeoptions automatically
		timeOptions = generateTimeOptions(rawTimeOptions);
	} else {
		timeOptions = rawTimeOptions; // array of time
	}

	return getCurrentTimeValue(timeOptions, value);
};

export default {
	generateDatesOfMonth,
	generateTimeOptions,
	getCurrentTimeValue,
	generateDefaultValue,
}
